module.exports = __webpack_public_path__ + "02c83290bdd06c9e3eddf4433fd00c3d.xml";